import type { User } from "@/models/user";
import { usersRepository } from "@/repositories/users.repository";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "@tanstack/react-router";

export const useAccountCheck = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [isChecking, setIsChecking] = useState(true);
  const hasCheckedRef = useRef(false);

  const allowList = ["/auth", "/login", "/register", "/ref"];
  const verifyList = ["/verify"];

  useEffect(() => {
    if (hasCheckedRef.current) return;
    hasCheckedRef.current = true;

    const fetchUser = async () => {
      console.log("🔍 Checking route permissions...");

      const isRouteAllowed = allowList.some((path) =>
        location.pathname.startsWith(path)
      );
      const isVerify = verifyList.some((path) =>
        location.pathname.startsWith(path)
      );
      const isRoot = location.pathname === "/";

      console.log("isRouteAllowed:", isRouteAllowed);
      console.log("isVerify:", isVerify);
      console.log("isRoot:", isRoot);
      console.log("Current location:", location.pathname);
      console.log("Token:", token);

      if (!token && !isRouteAllowed) {
        console.log("➡️ No token, redirecting to /register");
        setIsChecking(false);
        return navigate({ to: "/register", replace: true });
      } else if (!token) {
        setIsChecking(false);
        return;
      }

      let user: User | null = null;
      if (token) {
        user = await usersRepository
          .getMe()
          .catch((err) => {
            console.log("❌ Error fetching user:", err);
            return null;
          });
      }

      console.log("Fetched user:", user);

      const isUserAllowed =
        !!user && user.verified && !!user.uid && !!user.crypto_wallet_address;

      console.log("isUserAllowed:", isUserAllowed);

      if (!user && !isRouteAllowed) {
        console.log("➡️ No user, redirecting to /register");
        setIsChecking(false);
        return navigate({ to: "/register", replace: true });
      }

      if (!isUserAllowed && !isVerify) {
        console.log("➡️ User not allowed, redirecting to /verify");
        setIsChecking(false);
        return navigate({ to: "/verify", replace: true });
      }

      if (isUserAllowed && (isVerify || isRouteAllowed || isRoot)) {
        console.log("➡️ User allowed, redirecting to /dashboard");
        setIsChecking(false);
        return navigate({ to: "/dashboard", replace: true });
      }

      console.log("✅ Staying on current page:", location.pathname);
      setIsChecking(false);
    };

    fetchUser();
  }, []);

  return { isChecking };
};